import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import { inject, ref, watch } from 'vue';

import { ExperienceWorkflow } from '@ply-io/ply-front-shared-utilities';

import { isTileElement } from '@/utils/element-service';

// This needs typing:
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useVModel = <T>(emit: any, props: any) => {
	const value = ref<T>(props.value);
	watch(
		() => props.value,
		() => {
			value.value = props.value;
		},
		{ deep: true, immediate: true }
	);
	watch(
		() => value.value,
		() => {
			emit('input', value.value);
		},
		{ deep: true }
	);
	return { value };
};

export const useInject = <Type>(key: Parameters<typeof inject<Type>>[0]): Type => {
	const injectionInterface = inject<Type>(key);
	if (!injectionInterface) {
		throw new Error(`Injection interface not found for ${key}`);
	}
	return injectionInterface;
};

export const getTileTitle = (workflow: ExperienceWorkflow) =>
	isTileElement(workflow.current_draft.ui_element.type) &&
	isObject(workflow.current_draft.ui_element.metadata.injectionStyle) &&
	'text' in workflow.current_draft.ui_element.metadata.injectionStyle &&
	isObject(workflow.current_draft.ui_element.metadata.injectionStyle.text) &&
	'value' in workflow.current_draft.ui_element.metadata.injectionStyle.text &&
	isString(workflow.current_draft.ui_element.metadata.injectionStyle.text.value)
		? workflow.current_draft.ui_element.metadata.injectionStyle.text.value
		: '';
